export default __webpack_public_path__ + "static/media/assetAddIcon.62ab4566.svg";